import React, { useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  ListItemText,
  Checkbox,
  OutlinedInput,
  Chip,
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Grid,
  ListItemButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import BlackWhiteSwitch from '../components/common/BlackWhiteSwitch';
import CreateButtonWithModal from '../components/common/CreateButtonWithModal';
import Tooltip from '../components/common/Tooltip';
import { Theme, useTheme } from '@mui/material/styles';

// Mock data creation
function createData(
    MarkupName: string,
  countryMarket: string,
  SubscriptionPlan: string,
  supplier: string,
  officeID: string,
  journeyType: string,
  cabinClass: string,
  firstDetails: Record<string, string>
) {
  return {
    MarkupName,
    countryMarket,
    SubscriptionPlan,
    supplier,
    officeID,
    journeyType,
    cabinClass,
    firstDetails
  };
}

// Sample rows
const rows = [
  createData(
    'Markup A',
    'India',
    'Retail',
    'Supplier X',
    'OFF101',
    'Round-Trip',
    'Economy',
    {
      'Brand Fares': 'Brand A',
    'Flight Type': 'Domestic',
    'From Date': '2023-01-01',
    'To Date': '2023-12-31',
    'Fare Type': 'Discounted',
    'Airlines Name': 'Airline A',
    'From Country': 'India',
    'To Country': 'USA',
    'From Any Airport': 'Yes',
    'To Any Airport': 'No',
    'Currency': 'INR',
    'Equipement Type': 'Airbus A320',
    'Markup by Passenger Type': 'Percentage',
    'Services Fees On': 'Yes',
    'Markup Type': 'Percentage',
    'Value USD $': '15',
    'Max Limit USD $': '35',
    'Tiered Markup (Price Band)': 'No',
    'Payment Method Surcharge': 'No',
    'Status': 'Active',
    }
  ),
];

// Subtable fields
const fareFields = ['Brand Fares', 'Flight Type', 'From Date', 'To Date', 'Fare Type', 'Airlines Name', 'From Country', 'To Country', 'From Any Airport', 'To Any Airport'];
const airlineFields = ['Currency', 'Device Type', 'Markup by Passenger Type', 'Services Fees On', 'Markup Type', 'Value USD $', 'Max Limit USD $', 'Tiered Markup (Price Band)', 'Payment Method Surcharge', 'Status'];

// Subtable component
function HorizontalSubtable({
  title,
  fields,
  firstDetails,
}: {
  title: string;
  fields: string[];
  firstDetails: Record<string, string>;
}) {
  return (
    <>
    
    <Box mb={4} className="innerTable">
      <Table size="small">
        <TableHead>
          <TableRow>
            {fields.map((field) => (
              <TableCell key={field} sx={{ fontWeight: 'bold' }}>{field}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {fields.map((field) => (
              <TableCell
              key={field}
              className={
                field === 'Status'
                  ? firstDetails[field] === 'Active'
                    ? 'ActiveClass'
                    : 'InActiveClass'
                  : undefined
              }
            >
              {firstDetails[field] || '-'}
            </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
    </>
  );
}
 
// Expandable row
function Row({ row }: { row: ReturnType<typeof createData> }) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
    
      <TableRow>
        <TableCell>{row.MarkupName}</TableCell>
        <TableCell>{row.countryMarket}</TableCell>
        <TableCell>{row.SubscriptionPlan}</TableCell>
        <TableCell>{row.supplier}</TableCell>
        <TableCell>{row.officeID}</TableCell>
        <TableCell>{row.journeyType}</TableCell>
        <TableCell>{row.cabinClass}</TableCell>
        <TableCell align="center">
          <IconButton size="small" onClick={() => setOpen(!open)} className="viewBtn">
            {open ? (
              <>
                View Less <KeyboardArrowUpIcon />
              </>
            ) : (
              <>
                View More <KeyboardArrowDownIcon />
              </>
            )}
          </IconButton>
        </TableCell>
        <TableCell align="center">
                  <Tooltip />
                </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={9} style={{ paddingBottom: 0, paddingTop: 0 }} className='innerTableBG'>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={2}>
              <HorizontalSubtable
                title=""
                fields={fareFields}
                firstDetails={row.firstDetails}
              />
              <HorizontalSubtable
                title=""
                fields={airlineFields}
                firstDetails={row.firstDetails}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProp = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: 'bottom' as 'bottom',
      horizontal: 'left' as 'left',
    },
    transformOrigin: {
      vertical: 'top' as 'top',
      horizontal: 'left' as 'left',
    },
    getContentAnchorEl: null, // Important for older versions of MUI v4; can omit for MUI v5+
  };

const label = [
  'Markup Name',
  'Country / Market',
  'Subscription Plan',
  'Supplier',
  'Office ID',
  'Journey Type',
  'Cabin Class',
];
const initialItems: string[] = ['Mondee', 'Voyzant', 'Mystifly', 'Nuitee'];
// Main Component
export default function FlightMarkups() {
    const [labelName, setLabelName] = React.useState<string[]>([]);
  
    const labelChange = (event: SelectChangeEvent<typeof labelName>) => {
      const {
        target: { value },
      } = event;
      setLabelName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
    };

    // const isAllSelected = names.length > 0 && airportName.length === names.length;
    
      const [leftItems, setLeftItems] = useState<string[]>(['All Select', ...initialItems]);
      const [rightItems, setRightItems] = useState<string[]>([]);
      const [selectedLeft, setSelectedLeft] = useState<string[]>([]);
      const [selectedRight, setSelectedRight] = useState<string[]>([]);
    
      const handleToggleLeft = (item: string) => {
        setSelectedLeft((prev) =>
          prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
        );
      };
    
      const handleToggleRight = (item: string) => {
        setSelectedRight((prev) =>
          prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
        );
      };
    
      const moveSelected = (
        from: string[],
        to: string[],
        selected: string[],
        setFrom: React.Dispatch<React.SetStateAction<string[]>>,
        setTo: React.Dispatch<React.SetStateAction<string[]>>,
        setSelected: React.Dispatch<React.SetStateAction<string[]>>
      ) => {
        let itemsToMove = selected;
    
        // If "All Select" is selected, move all except "All Select"
        if (selected.includes('All Select')) {
          itemsToMove = from.filter((item) => item !== 'All Select');
        }
    
        setFrom(from.filter((item) => !itemsToMove.includes(item) && item !== 'All Select'));
        setTo([...to, ...itemsToMove]);
        setSelected([]);
      };
    
      const moveAll = (
        from: string[],
        to: string[],
        setFrom: React.Dispatch<React.SetStateAction<string[]>>,
        setTo: React.Dispatch<React.SetStateAction<string[]>>,
        setSelected: React.Dispatch<React.SetStateAction<string[]>>
      ) => {
        const filtered = from.filter((item) => item !== 'All Select');
        setTo([...to, ...filtered]);
        setFrom([]);
        setSelected([]);
      };
    
      const renderList = (
      items: string[],
      selectedItems: string[],
      toggleFunction: (item: string) => void
    ) => (
      <Paper sx={{ width: 75, height: 200, overflow: 'auto', boxShadow: 'none' }}>
        <List dense role="list">
          {items.map((item) => (
            <ListItem key={item} disablePadding>
              <ListItemButton
                selected={selectedItems.includes(item)}
                onClick={() => toggleFunction(item)}
              >
                <ListItemText primary={item} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    );

    
  return (
    <>
    <Box className="headingBtnWrap">
      <Typography variant="h1">Markups</Typography>
      <CreateButtonWithModal modalTitle="Markups">
        <Box className="modalFormWrap">
          <Box component="form" className="modalForm">
            <Box className="feeModalForm">
              <Typography variant="subtitle1" gutterBottom>User Targeting</Typography>
              <Box className="feeInputFieldWrap">
              {['Markup Name' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              </Box>
              <Typography variant="subtitle1" gutterBottom>Source</Typography>
              <Box className="feeInputFieldWrap">
              {['Country / Market', 'Subscription Plan' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              <div className="form-control inputFieldWrap healthWrap supplierWrap">
                              <label>Supplier</label>
                               <Accordion className='healthAccordian'>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                          <Box className="healthHeaderBox supplierBox">
                                      <Box>Select Supplier</Box>
                                  </Box>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box className="healthBoxWrap supplierBoxWrap">
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                      <Box>{renderList(leftItems, selectedLeft, handleToggleLeft)}</Box>
              
                      <Box>
                        <Grid container direction="column" alignItems="center" gap={1}>
                          <Button
                            variant="outlined"
                            onClick={() =>
                              moveSelected(leftItems, rightItems, selectedLeft, setLeftItems, setRightItems, setSelectedLeft)
                            }
                            disabled={selectedLeft.length === 0}
                          >
                            &gt;
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => moveAll(leftItems, rightItems, setLeftItems, setRightItems, setSelectedLeft)}
                            disabled={leftItems.length === 0}
                          >
                            All &gt;&gt;
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => moveAll(rightItems, leftItems, setRightItems, setLeftItems, setSelectedRight)}
                            disabled={rightItems.length === 0}
                          >
                            &lt;&lt; All
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() =>
                              moveSelected(rightItems, leftItems, selectedRight, setRightItems, setLeftItems, setSelectedRight)
                            }
                            disabled={selectedRight.length === 0}
                          >
                            &lt;
                          </Button>
                        </Grid>
                      </Box>
              
                      <Box>{renderList(rightItems, selectedRight, handleToggleRight)}</Box>
                    </Grid>
                              </Box>
                      </AccordionDetails>
                    </Accordion>
                          </div>
                          <div className="form-control inputFieldWrap">
                  <label>Office ID</label>
                  <input type="text" className="inputField" />
                </div>
              </Box>
              <Typography variant="subtitle1" gutterBottom>Trip Criteria</Typography>
              <Box className="feeInputFieldWrap">
              {['Journey Type', 'Cabin Class', 'Brand Fares', 'Flight Type', 'From Date', 'To Date' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              </Box>
              <Typography variant="subtitle1" gutterBottom>Route Criteria</Typography>
              <Box className="feeInputFieldWrap">
              {['Fare Type', 'Airlines Name', 'From Country', 'To Country', 'From Any Airport', 'To Any Airport' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              </Box>
              <Typography variant="subtitle1" gutterBottom>Pricing Logic</Typography>
              <Box className="feeInputFieldWrap">
              {['Currency', 'Device Type', 'Markup by Passenger Type', 'Services Fees On', 'Markup Type', 'Value USD $', 'Max Limit USD $', 'Tiered Markup (Price Band)', 'Payment Method Surcharge' ].map((label) => (
                <div className="form-control inputFieldWrap" key={label}>
                  <label>{label}</label>
                  <input type="text" className="inputField" />
                </div>
              ))}
              </Box>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" className='formBtn'>Save</Button>
          </Box>
        </Box>
        <BlackWhiteSwitch />
      </CreateButtonWithModal>
    </Box>
    <Box className="searchInputWrap">
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        p={2}
        sx={{ width: '100%'}}
        className="searchInputFilterBox"
      >
        <FormControl sx={{ minWidth: 460 }}>
           <Select
            className='leftFilterBox'
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={labelName}
            onChange={labelChange}
            displayEmpty
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return 'Select';  // <-- Placeholder text
              }
              return selected.join(', ');
            }}
            MenuProps={MenuProp}
          >
            <MenuItem disabled value="">
            Select
            </MenuItem>
            {label.map((name) => (
              <MenuItem key={name} value={name} className='selectDropdown'>
                <Checkbox checked={labelName.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <TextField
          className="leftSearchFilter"
          fullWidth
          variant="outlined"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleSearch();
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton onClick={handleSearch} edge="start">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <Button
                variant="contained"
                className="searchBtn"
                color="primary"
                type="submit"
                sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                onClick={handleSearch}
              >
                Search
              </Button>
            ),
          }}
        /> */}
        <Button
                variant="contained"
                className="searchBtn"
                color="primary"
                type="submit"
                sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              >
                Search
              </Button>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }} className="dynamicInputFieldWrap">
        {labelName.map((item) => (
          <div key={item} className="form-control inputFieldWrap">
            <label style={{ marginBottom: '4px', fontWeight: '500' }}>{item}</label>
            <input
              type="text"
              // placeholder={`Enter ${item}`}
              className="inputField"
            />
          </div>
        ))}
      </Box>
    </Box>
    <Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Markup Name</TableCell>
              <TableCell>Country / Market</TableCell>
              <TableCell>Subscription Plan</TableCell>
              <TableCell>Supplier</TableCell>
              <TableCell>Office ID</TableCell>
              <TableCell>Journey Type</TableCell>
              <TableCell>Cabin Class</TableCell>
              <TableCell align="center">Actions</TableCell>
              <TableCell align="center">Audit Trail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <Row key={index} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
    </>
  );
}
